import "./App.css";
import Dashboard from "./components/Dashboard";
import DashboardLayout from "./components/DashboardLayout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import AuthLayout from "./components/layouts/AuthLayout";
import { PrivateRoute } from "./components/routes/PrivateRoute";
import ProtectedLayout from "./components/layouts/ProtectedLayout";
import GlobalApiLoader from "./components/Loader/GlobalApiLoader";

function App() {
  return (
    <>
      <ToastContainer />
      <GlobalApiLoader />
      <Router basename="/">
        <Routes>
          {/* Routes for login part */}
          <Route exact path="/auth/*" element={<AuthLayout />} />
          {/* <Route path='/' element={<LoginLayout><LoginForm /></LoginLayout>} /> */}
          {/* <Route path='/forgot-password' element={<LoginLayout><ForgotPassword /></LoginLayout>} /> */}

          {/* Routes for dashboard part (Protected Route) */}

          <Route
            exact
            path="/*"
            element={
              <PrivateRoute>
                <ProtectedLayout>
                  <DashboardLayout>
                    <Dashboard />
                  </DashboardLayout>
                </ProtectedLayout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
